import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import ActionButtons from '../Common/ActionButtons';
import Products from './Products';
import Tools from './Tools';
import useUserInfo from "../../hooks/useUserInfo";
import PermissionTypes from "../../constants/PermissionTypes";
import ResourceCenterHighLevel from "./SubComponents/ResourceCenterHighLevel";
import CaseTableHighLevelView from './SubComponents/CaseStatusHighLevelView';
import './AdvisorWelcome.scss';

export default function AdvisorWelcome(props) {

  const { firstName, firstTimeLogin, role, permissions } = useUserInfo();

  const defaultState = {
    showDetailView: false,
    selectedCaseDetails: null,
    detailViewLoading: false
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [state, updateState] = useState(defaultState);

  const openCaseDetail = (referenceID) => {
    props.history.push(`/ActivityCenter/${referenceID}`);
  };

  const closeCaseDetail = () => {
    updateState({ ...state, showDetailView: false, selectedCaseDetails: null });
  }

  if (!firstName) {
    return <div className="d-flex justify-content-center p-5"><CircularProgress /></div>;
  }

  return (
      <div>
        <div className="py-3 d-flex">
          <h1>Welcome{firstTimeLogin === false ? " " : ","}{firstTimeLogin === false ? "Back," : ""} {firstName}</h1>
        </div>
        <div className='action-button-position'>
          <ActionButtons role={role} />
        </div>
        <div className='case-table'>
          {permissions.includes(PermissionTypes.VIEW_CASE_STATUS) ?
            <CaseTableHighLevelView openCaseDetail={openCaseDetail} closeCaseDetail={closeCaseDetail} /> : ''}
        </div>
        <Products ishomePage={true} />
        <Tools ishomePage={true} />
        <ResourceCenterHighLevel />
      </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Home/AdvisorWelcome.js